import { render, staticRenderFns } from "./TabMemberAlbum.vue?vue&type=template&id=0a2a98a0"
import script from "./TabMemberAlbum.vue?vue&type=script&lang=js"
export * from "./TabMemberAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports